import qs from 'qs';
import fetchCommonInfo from '@/utils/commonConfig';
// import inputUpBubbleInfo from '@/mock/cgi/v1/receptionConf/webim/inputUpBubbleInfo.js'
import globalWin from '@/utils/globalWin';
export default {
  data() {
    return {
      bubbleConfig: {},
    };
  },
  computed: {
    // 是否有数据
    hasBubble() {
      const { bubbles, robotBubbles, aioUpBubbles } = this.bubbleConfig;
      const hasBubbles = bubbles && bubbles.length;
      const hasAioUpBubbles = !!aioUpBubbles?.menuJson?.content?.menu?.list?.length;
      const hasRobotBubbles = !!robotBubbles?.menuJson?.content?.menu?.list?.length;
      return hasBubbles || hasAioUpBubbles || hasRobotBubbles;
    },
  },
  watch: {
    // 获取到值后再去请求
    reception: {
      handler(newValue, oldValue) {
        const { robotId, extuin, inWaitPool } = newValue;
        const { robotId: oldRobotId, extuin: oldExtuin } = oldValue;
        if (robotId !== oldRobotId || extuin !== oldExtuin || inWaitPool) {
          this.bubbleConfig = {};
          this.getBubbleConfig();
        }
      },
      deep: true,
    },
  },
  // mounted() {
  //   this.getBubbleConfig()
  // },

  methods: {
    /**
     * @desc 气泡配置
     */
    async getBubbleConfig() {
      // 获取url 参数
      const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      // 获取配置
      const fields = ['inputUpInfoForCommon', 'tools'];
      const { extuin, inWaitPool } = this.reception;
      this.reception.robotId && fields.push('inputUpInfoForRobot');
      (extuin || inWaitPool) && fields.push('inputUpInfoForHuman');
      const { kfuin, wpaId, visitorid, key } = this.wpaDetail;
      const body = {
        kfuin: params.kfuin || kfuin,
        robotId: this.reception.robotId,
        type: 0,
        visitorId: visitorid,
        wpaId,
        fields,
        key,
      };
      if (globalWin.robotTestMode) {
        body.answerTestFlag = true;
      }
      fetchCommonInfo(body, ({ inputUpInfoForHuman = {}, inputUpInfoForCommon = {}, inputUpInfoForRobot = {},
        tools = {} }) => {
        try {
          const { code, data = {} } = tools;
          if (+code === 0) {
            this.showInfo.isSurvey = data.isSurvey;
            this.showInfo.isSurveyValid = data.isSurveyValid;
            this.showInfo = JSON.parse(JSON.stringify(this.showInfo));
          }
          let bubbles = inputUpInfoForCommon?.data || {};
          let robotBubbles = inputUpInfoForRobot?.data || {};
          let aioUpBubbles = inputUpInfoForHuman?.data || {};
          // 排队中场景时需要特殊处理一下，仅展示退出排队这个气泡
          robotBubbles = this.handleBubbles(robotBubbles);
          aioUpBubbles = this.handleBubbles(aioUpBubbles);
          bubbles = this.handleBubbles(bubbles);
          this.bubbleConfig = {
            bubbles,
            robotBubbles,
            aioUpBubbles,
          };
          let type;
          if (this.bubbleConfig.aioUpBubbles?.menuJson?.content?.menu?.list?.length) {
            type = 'forHuman';
          } else if (bubbles && bubbles.length && bubbles !== 'null') {
            type = 'normal';
          } else if (this.bubbleConfig.robotBubbles?.menuJson?.content?.menu?.list?.length) {
            type = 'robot';
          }

          this.bubbleConfig.type = type;
          console.log('bubbleConfig', this.bubbleConfig);
        } catch {

        }
      });
    },

    handleBubbles(bubbles) {
      try {
        const { inWaitPool } = this.reception;
        const isSurveyValid = this?.showInfo?.isSurveyValid;
        let list = bubbles?.menuJson?.content?.menu?.list || (Array.isArray(bubbles) && bubbles);
        if (list && list.length) {
        // 退出排队按钮只在排队时出现，其他情况下隐藏
          const exitBubbleIdx = list.findIndex(item => item.action === 99 && item?.meta?.type === 1);
          // 有退出排队并且在排队中，只展示退出排队
          if (exitBubbleIdx > -1 && inWaitPool) {
            list = [list[exitBubbleIdx]];
          // 不在排队中但是有退出排队，删除退出排队
          } else if (exitBubbleIdx > -1) {
            list.splice(exitBubbleIdx, 1);
          // 在排队中但是没有退出排队气泡，清空
          } else if (inWaitPool) {
            list = [];
          }
          const surveyBubbleIdx = list.findIndex(item => item.action === 99 && item.meta.type === 3);
          if (surveyBubbleIdx > -1 && !isSurveyValid) {
            list.splice(surveyBubbleIdx, 1);
          }
          if (Array.isArray(bubbles)) {
            bubbles = list;
          } else {
            bubbles.menuJson.content.menu.list = list;
          }
        }
        return bubbles;
      } catch (e) {
        console.log('handleBubbles_catch', e);
        return bubbles;
      }
    },
    // 隐藏输入框上方气泡
    hideBubble() {
      this.bubbleConfig = {};
    },
  },
};
